import GestaoCobranca from "views/adm-franquias/gestao-cobranca/page";

export default function ExtratoServico() {
  return <GestaoCobranca view="client" />;
}
